import { HELP_INFOGRAPH_URL } from 'constants/infograph';

import { LinkButtonKey } from './LinkButton.helpers';

interface HelpLink {
  key: LinkButtonKey;
  title: string;
  url?: string;
}

// Function to create help links
export const createHelpLinks = (t: (key: string) => string): HelpLink[] => {
  return [
    {
      key: 'help-center',
      title: t('navbar.help-center'),
      url: `${HELP_INFOGRAPH_URL}/hc/en-us`,
    },
    {
      key: 'learn-the-basics',
      title: t('navbar.learn-the-basics'),
      url: `${HELP_INFOGRAPH_URL}/hc/en-us/sections/14547499351309-Upgraded-Editor-Beta-basics-`,
    },
    {
      key: 'keyboard-shortcuts',
      title: t('navbar.keyboard-shortcuts'),
      url: `${HELP_INFOGRAPH_URL}/hc/en-us/articles/11012978217613`,
    },
    {
      key: 'email-us',
      title: t('navbar.email-us'),
      url: 'mailto:support@venngage.com',
    },
    {
      key: 'chat-with-us',
      title: t('navbar.chat-with-us'),
    },
  ];
};
